export const screenName = 'fee-term-invest-link';
